import { DINEIN_TYPE, PICKUP_TYPE } from '../webStorage/keys/sessionKeys';

export const isPaymentPending = (order, prePaidOrderEnabled) => {
  const is_prepaid_enabled =
    prePaidOrderEnabled?.prePaidEnabledfromShannon && prePaidOrderEnabled?.enabledForOrderType;
  const is_payLater_enabled = prePaidOrderEnabled?.payLaterEnabledFromShannon;

  const is_order_postpaid =
    !is_prepaid_enabled &&
    (order?.order_type == DINEIN_TYPE ||
      (order?.order_type == PICKUP_TYPE &&
        order?.table_id == 'takeaway' &&
        is_payLater_enabled &&
        order?.pay_with_cash));

  return Number(order?.bill?.balance || order?.bill?.data?.balance) > 0 && !is_order_postpaid;
};
